import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import geofences from 'APP_ROOT/data/geofences';

import ResourceGroup from '../ResourceGroup';
import Geofence from './Geofence';
import { setSelectedResource } from '../../actions';
import { strings } from '../../../../../localization';
import Protected from '../../../../../components/common/protected';

export class Geofences extends React.PureComponent {

    componentDidMount() {
        if (this.props.activeGeofenceIds.length === 0) { // avoid resetting activeGeofenceIds unnecessarily
            // will refresh active geofences if not loaded or if user does not have geofences yet (pre-existing behaviour before the above check was added)
            this.props.loadActiveGeofences(this.props.stage);
        }
    }

    componentDidUpdate(prevProps) {
        const { activeGeofenceIds } = this.props;
        
        if(prevProps.activeGeofenceIds !== activeGeofenceIds) {
            this.checkSelectedResourceExists(this.props.selectedResource, activeGeofenceIds);
        }
    }

    checkSelectedResourceExists = (selectedResource, activeGeofenceIds) => {
        const { resourceType, resourceId } = selectedResource;

        if (resourceType !== 'geofence') return;

        if (resourceId && !activeGeofenceIds.includes(resourceId)) {
            if (activeGeofenceIds.length > 0) {
                this.props.setSelectedResource('geofence', activeGeofenceIds[0]);
            }
        }
    }

    setVisible = (geofenceId, visible) => {
        this.props.setVisible(geofenceId, visible);
        this.props.pokeMap();
    }

    setAllVisible = (type, visible) => {
        // ignore type. we know it's geofences
        this.props.setAllGeofencesVisible(visible);
        this.props.pokeMap();
    }

    addNewGeofence = () => {
        if (this.props.geofenceGeometryEditModeActive) {
            console.error('addNewGeofence called while geofenceGeometryEditModeActive');
            return;
        }

        this.props.addNewGeofence();
        this.props.setDetailPanelOpen(true);
    }

    render() {
        const {
            activeGeofenceIds,
            geofenceNameForId,
            geofenceVisibilityForId,
            loading,
            features,
            geofenceGeometryEditModeActive,
            ...rest
        } = this.props;

        const limit = features.geofence_limit;
        const activeGeofenceCount = activeGeofenceIds.length;

        const limitElement = limit && !loading ? (
            <small title={strings.formatString(strings.geofences_you_are_using_x_of_x_active_geofences, activeGeofenceCount, limit)}>
                {`(${activeGeofenceCount}/${limit})`}
            </small>
        ) : null;

        const footer = (<Protected resource='geofences' action='write'>
                            {(!limit || limit > activeGeofenceCount) ?
                            <>
                                <button disabled={geofenceGeometryEditModeActive} className='btn btn-blue btn-sm' onClick={this.addNewGeofence}>
                                    {strings.geofences_add_geofence}
                                </button>
                                <div className='goefences-limit-positioned-right'>
                                    {limitElement}
                                </div>
                            </>
                            : limitElement}
                        </Protected>);

        return (
            <ResourceGroup
                {...rest}
                type='geofence'
                items={activeGeofenceIds}
                geofenceNameForId={geofenceNameForId}
                geofenceVisibilityForId={geofenceVisibilityForId}
                itemFactory={itemFactory}
                setAllVisible={this.setAllVisible}
                footer={footer}
                footerHeight={26}
                renderEmptyList={true}
                loading={loading}
                setVisible={this.setVisible}
            />
        );
    }
}

const itemFactory = (it, props) => (
    <Geofence
        key={it}
        stage={props.stage}
        geofenceId={it}
        editingName={props.editingNameFor === it}
        onSelectResource={props.onSelectResource}
        selected={props.selectedId === it} 
        setVisible={props.setVisible}
        setEditingItemName={props.setEditingItemName}
    />
);

Geofences.propTypes = {
    stage: PropTypes.string.isRequired,
    loadActiveGeofences: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    addNewGeofence: PropTypes.func.isRequired,
}

const mapStateToProps = (state, ownProps) => {
    return {
        activeGeofenceIds: geofences.Selectors.activeGeofenceIds(state),
        geofenceNameForId: (geofenceId) => geofences.Selectors.geofenceName(state, geofenceId),
        geofenceVisibilityForId: (geofenceId) => geofences.Selectors.isGeofenceVisible(state, geofenceId),
        loading: geofences.Selectors.loading(state),
    };
};

const mapDispatchToProps = {
    loadActiveGeofences: geofences.Actions.loadActiveGeofences,
    setVisible: geofences.Actions.setGeofenceVisible,
    setAllGeofencesVisible: geofences.Actions.setAllGeofencesVisible,
    addNewGeofence: geofences.Actions.addNewGeofence,
    setSelectedResource,
};

export default connect(mapStateToProps, mapDispatchToProps)(Geofences);
